module.exports = __webpack_public_path__ + "static/img/3101-2.35ec0362.jpg";